import React from 'react';

const ChatSupportCard = () => {
  return (
    <div className="ds-card _textAlign_center">
      <section className="cardSection">
        <div className="_displayFlex _justifyContent-center _alignItems-center _marginBottom--normal">
          <h4 className="-darkBlue _marginBottom--none _marginRight--normal"> Have a question? </h4>
          <button
            onClick={() => { window.zE('webWidget', 'open') }}
            className="ds-btn --small _outline -secondary _padding--small-mobileOnly _fontSize--xsmall-mobileOnly"
          >
            Chat with support
          </button>
        </div>

        <p className="copy _fontSize--small">
          You can also email us at
          <a href="mailto:support@firstcircle.com"> support@firstcircle.com </a>
          or contact your account manager.
        </p>
      </section>
    </div>
  );
}

export default ChatSupportCard;



// WEBPACK FOOTER //
// ./src/features/home/components/ChatSupportCard.js